export default "__VITE_ASSET__DuxA$Ogh__"